// Representa un arreglo en el cual el codigo del modulo debe hacer match con el modulo que venga de la coleccion de modulos de la empresa 
// Este js debe ser utilizado unicamente en el modulode LOGIN en los demas modulos no debe estar 


// Se importan las imagenes que corresponden a cada uno  de los modulos que va tener el set 
// Se extrae en forma de objeto puesto que los componentes lo piden como objeto 
import ImgFinancieraContable from '../../Activos/Imagenes/Modulos/financiera_contable.svg';
import ImgAcademica from '../../Activos/Imagenes/Modulos/academica.svg';
import ImgConfiguracion from '../../Activos/Imagenes/Modulos/configuracion.svg';
import ImgSeguridad from '../../Activos/Imagenes/Modulos/seguridad.svg';

const SetModulos = {
    Modulos: [
        {
            Modulo: "AC_C",
            Titulo: "ÁREA ACADÉMICA",
            Submodulo: "CLASS",
            UrlModulo: "https://www.innovasof.com/",
            Imagen: ImgAcademica,
            Leyenda: "Realice todas sus gestiones académicas de forma segura y eficiente",
            Acceso: false,
            Favorites: false,
            Referencia: 'Class',
            Icono: '',
            ModuloExterno: false
        },                
        {
            Modulo: "SECUR",
            Titulo: "ÁREA SEGURIDAD",
            Submodulo: "Seguridad",
            UrlModulo: "https://www.innovasof.com/",
            Imagen: ImgSeguridad,
            Leyenda: "Gestione la seguridad del sistema",
            Acceso: false,
            Favorites: false,
            Referencia: 'Seguridad',
            Icono: '',
            ModuloExterno: false
        },
        {
            Modulo: "PARAM",
            Titulo: "ÁREA PARAMETRIZACIÓN",
            Submodulo: "Parametros",
            UrlModulo: "https://www.innovasof.com/",
            Imagen: ImgConfiguracion,
            Leyenda: "Realice las configuraciones generales del sistema",
            Acceso: false,
            Favorites: false,
            Referencia: 'Parametros',
            Icono: '',
            ModuloExterno: false
        },
        {
            Modulo: "INTEGRA",
            Titulo: "ÁREA INTEGRACIONES",
            Submodulo: "Integraciones",
            UrlModulo: "https://www.innovasof.com/",
            Imagen: ImgConfiguracion,
            Leyenda: "Gestione las integraciones del sistema",
            Acceso: false,
            Favorites: false,
            Referencia: 'Integraciones',
            Icono: '',
            ModuloExterno: false
        },
        {
            Modulo: "INTEG-PRO",
            Titulo: "ÁREA INTEGRACIONES",
            Submodulo: "IntegracionesAdm",
            UrlModulo: "https://www.innovasof.com/",
            Imagen: ImgConfiguracion,
            Leyenda: "Gestione los procesos de integraciones del sistema",
            Acceso: false,
            Favorites: false,
            Referencia: 'IntegracionesAdm',
            Icono: '',
            ModuloExterno: false
        },        
        {
            Modulo: "CXC",
            Titulo: "ÁREA FINANCIERO CONTABLE",
            Submodulo: "Cuentas por Cobrar",
            UrlModulo: "https://www.innovasof.com/",
            Imagen: ImgFinancieraContable,
            Leyenda: "Gestione las cuentas por cobrar",
            Acceso: false,
            Favorites: false,
            Referencia: 'CuentasCobrar',
            Icono: '',
            ModuloExterno: false
        },
        {
            Modulo: "CAJAS",
            Titulo: "ÁREA FINANCIERO CONTABLE",
            Submodulo: "Cajas",
            UrlModulo: "https://www.innovasof.com/",
            Imagen: ImgFinancieraContable,
            Leyenda: "Realice todas sus gestiones de facturación",
            Acceso: false,
            Favorites: false,
            Referencia: 'Cajas',
            Icono: '',
            ModuloExterno: false
        },
        {
            Modulo: "ANALYZE",
            Titulo: "ÁREA INTEGRACIONES",
            Submodulo: "Analyze",
            UrlModulo: "https://www.innovasof.com/",
            Imagen: ImgConfiguracion,
            Leyenda: "Gestione los reportes del sistema",
            Acceso: false,
            Favorites: false,
            Referencia: 'Analyze',
            Icono: '',
            ModuloExterno: false
        },
        {
            Modulo: "CORPORATIVO",
            Titulo: "ÁREA INTEGRACIONES",
            Submodulo: "Corporativo",
            UrlModulo: "https://www.innovasof.com/",
            Imagen: ImgConfiguracion,
            Leyenda: "Gestione las cuentas corpórativas",
            Acceso: false,
            Favorites: false,
            Referencia: 'Corporativo',
            Icono: '',
            ModuloExterno: false
        },
        {
            Modulo: "MIGRADOR",
            Titulo: "ÁREA INTEGRACIONES",
            Submodulo: "Migrador",
            UrlModulo: "https://www.innovasof.com/",
            Imagen: ImgConfiguracion,
            Leyenda: "Gestione los modelo de migración de datos y el procesamiento de información",
            Acceso: false,
            Favorites: false,
            Referencia: 'Migrador',
            Icono: '',
            ModuloExterno: false
        }
    ]
};

export default SetModulos;